import { render } from "./TroPhy.vue?vue&type=template&id=f72a47f2"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/TroPhy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f72a47f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f72a47f2', __exports__)) {
    api.reload('f72a47f2', __exports__)
  }
  
  module.hot.accept("./TroPhy.vue?vue&type=template&id=f72a47f2", () => {
    api.rerender('f72a47f2', render)
  })

}


export default __exports__